var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('router-view'),_c('sf-message-box',{attrs:{"okLabel":_vm.getMessage_('SWCC000560'),"cancelLabel":_vm.getMessage_('SWCC000561')}}),_c('sf-loading'),_c('screen-counter-modal',{ref:"sessionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }